module.exports = __webpack_public_path__ + "img/Wagon_Front.e1774e50.svg";